import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-av-pg-title',
  templateUrl: './av-pg-title.component.html',
  styleUrls: ['./av-pg-title.component.scss']
})
export class AvPgTitleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
